import React from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import styles from 'styles';

class HtmlContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenDialog: false,
            disabledButton: true,
        };

        this.toggleDialog = this.toggleDialog.bind(this);
    }

    toggleDialog() {
        this.setState({
            isOpenDialog: !this.state.isOpenDialog,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            disabledButton: !nextProps.letter.html,
            letter: nextProps.letter,
        });
    }


    render() {
        const { isOpenDialog, disabledButton } = this.state;
        const { letter } = this.props;

        const actions = [
            <FlatButton
                label='CLOSE'
                primary
                onClick={this.toggleDialog}
            />,
        ];

        return (
            <div className="btn">

                <RaisedButton
                    onClick={this.toggleDialog}
                    disabled={disabledButton}
                    label='HTML'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                    primary
                />

                <Dialog
                    title='HTML'
                    actions={actions}
                    modal={false}
                    contentStyle={styles.Dialog}
                    open={isOpenDialog}
                    onRequestClose={this.toggleDialog}
                >
                        {/* sandbox should be an empty string to prevent errors in console */}
                        <iframe srcDoc={letter.html} sandbox="" style={{ overflow: 'auto', border: 'none', width: '100%', height: '65vh' }} ref="iframe" frameBorder="0">

                        </iframe>
                </Dialog>
            </div>

        );
    }
}

export default HtmlContent;


// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/HtmlContent.jsx